class Anchor {
    constructor() {
        $('.js-anchor a').each(function () {
            let $this = $(this);
            $this.on('click', function (e) {
                e.preventDefault();
                let target = $this.attr('href');
                let margin = $('#js-global-header').height();
                if ($('.renovation-arise__anchor').length > 0) {
                    margin = margin + $('.renovation-arise__anchor').height();
                }
                if (window.UA.isSP) {
                    if ($('.buyer-survey #js-sp-nav').length > 0) {
                        margin = margin + $('.buyer-survey #js-sp-nav').height();
                    }
                    if ($('.wellness-content__main-spnav').length > 0) {
                        margin = margin + $('.wellness-content__main-spnav').height();
                    }
                    if($('.style-detail__facility-nav').length > 0) {
                        margin = margin + $('.style-detail__facility-nav').height();
                    }
                }
                // console.log($('#js-global-header').height(), $('.renovation-arise__anchor').height(), margin);
                $('html, body')
                    .stop()
                    .animate({
                            scrollTop: $(target).offset().top - margin
                        },
                        1000
                    );
            });
        });
    }
}
export default Anchor;